import { Component, OnInit, Input } from "@angular/core";

@Component({
    selector: "dodo-text-box",
    templateUrl: "./text-box.component.html",
    styleUrls: ["./text-box.component.scss"],
    standalone: false
})
export class TextBoxComponent implements OnInit {
	@Input() settings: any;
	inputValue: String;
	constructor() {}

	ngOnInit() {}
}
